import type { ComponentProps } from 'react';

export const CancelIcon = (props: ComponentProps<'svg'>) => {
  return (
    <svg
      {...props}
      fill='none'
      height='24'
      viewBox='0 0 24 24'
      width='24'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        clipRule='evenodd'
        d='M13.4154 12.0002L19.7075 5.7081C20.0984 5.31752 20.0984 4.68377 19.7075 4.29319C19.3166 3.90227 18.6835 3.90227 18.2926 4.29319L12.0005 10.5853L5.7081 4.29319C5.31718 3.90227 4.68411 3.90227 4.29319 4.29319C3.90227 4.68377 3.90227 5.31752 4.29319 5.7081L10.5856 12.0002L4.29319 18.2922C3.90227 18.6828 3.90227 19.3166 4.29319 19.7071C4.48865 19.9023 4.74481 20 5.00065 20C5.25648 20 5.51264 19.9023 5.7081 19.7068L12.0005 13.4147L18.2926 19.7068C18.488 19.9023 18.7442 20 19 20C19.2559 20 19.512 19.9023 19.7075 19.7068C20.0984 19.3162 20.0984 18.6825 19.7075 18.2919L13.4154 12.0002Z'
        fill='white'
        fillRule='evenodd'
      />
    </svg>
  );
};
